module.exports = __webpack_public_path__ + "img/brikcombi.88a7a280.gif";